import {
    REQUEST_PBN,
    RECEIVE_PBN, ERROR_PBN, CLEAR_ERROR
} from '../actions'

function pbnRequest(
    state = {
        isFetching:false,
        gameType: '4hands',
        table: 0,
        board: 0,
        error: ''
    },
    action)
{
    switch (action.type) {
        case CLEAR_ERROR:
            if (state.error === '') {
                return state;
            }

            return Object.assign(
                {},
                state,
                {error: ''}
            );
        case REQUEST_PBN:
            return {
                isFetching: true,
                gameType: action.gameType,
                table: action.table,
                board: action.board,
                error: ''
            };
        case RECEIVE_PBN:
            return {
                isFetching: false,
                gameType: action.gameType,
                table: action.table,
                board: action.board,
                error: ''
            };
        case ERROR_PBN:
            return {
                isFetching: false,
                gameType: action.gameType,
                table: action.table,
                board: action.board,
                error: action.error.message
            };
        default:
            return state;
    }
}

export default pbnRequest;